export default "__VITE_ASSET__1123cc6c__"